import { render, staticRenderFns } from "./HistogramChart.vue?vue&type=template&id=a45bb422&scoped=true&"
import script from "./HistogramChart.vue?vue&type=script&lang=js&"
export * from "./HistogramChart.vue?vue&type=script&lang=js&"
import style0 from "./HistogramChart.vue?vue&type=style&index=0&id=a45bb422&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45bb422",
  null
  
)

export default component.exports